import { useEffect, useState } from "react";
import { useGetRoutesObjects } from "contexts/RoutesObjectContext";
import {ICityLiteAsset} from "models/Assets/ICityAsset";

export const CITY_CHANGE_EVENT_NAME = "on-change-city";
export const useGetCity = () :ICityLiteAsset => {
  const { city: def } = useGetRoutesObjects();
  const [city, setCity] = useState<ICityLiteAsset>(def);
  useEffect(() => {
    const onSuccess = (e) => setCity(e.detail.cityUpdated);
    document.addEventListener(CITY_CHANGE_EVENT_NAME, onSuccess);
    return () =>
      document.removeEventListener(CITY_CHANGE_EVENT_NAME, onSuccess);
  }, []);
  return  city ;
};
